const ACTIONS = {
    USER_LOGGED_IN: 'TRAVELER/USER_LOGGED_IN'
};

const ACTION_CREATORS = {
    setUserLoggedIn({isLoggedIn}) {
        return {
            type: ACTIONS.USER_LOGGED_IN,
            payload: {
                isLoggedIn
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
